"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const creditcardamexfrontview = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 194 121",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-creditcardamexfrontview` : '') + (description ? ` desc-creditcardamexfrontview` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-creditcardamexfrontview"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-creditcardamexfrontview"
  }, description), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#62abbc",
    width: "194",
    height: "121",
    rx: "5",
    ry: "5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M86.58,45,78.69,27.28H68.61V52.7L57.22,27.28H48.6L37.2,53.72h6.87l2.34-6h13l2.48,6H75V34l8.62,19.72h6l8.77-19.28V53.72h6.43V27.28H94.47ZM53,42H49L53,32.83v.29L56.92,42Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M145.31,40.06l4.67-5,6.82-7.74h-8.13l-7.31,8-7.3-8H108.49V53.5h24.83l7.74-8.62,7.6,8.76h8.13l-6.82-8Zm-15.48,8H115.07V42.84h14.32v-5H115.07V33h14.75l7.3,7Z"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#fff",
    x: "139.99",
    y: "72.72",
    width: "34.01",
    height: "18.32"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    fill: "none",
    stroke: "#cb2026",
    cx: "157.97",
    cy: "82.12",
    rx: "32.68",
    ry: "17.67"
  }));
};
var _default = exports.default = creditcardamexfrontview;